<div class="container-fluid service-bg from-top-pad">
    <div class="row">
        <div class="col-md-12">
            <h1>
                {{'gen_rentals_history' | translate}}
            </h1>
        </div>
        <div class="col-md-12 my-5 clr-sec-text text-center" *ngIf="!payments?.length">
            <h2>{{'gen_no_data' | translate}}</h2>
        </div>
        <div class="col-md-12 my-3" infiniteScroll [infiniteScrollDistance]="2" (scrolled)="onScroll()"
            *ngIf="payments?.length">
            <div class="table-container">
                <table mat-table [dataSource]="payments" class="mat-elevation-z8 w-100">
                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element;let i = index;">
                            {{i + 1}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef> {{'gen_title' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <a *ngIf="element.assetExists" [href]="'#/details/' + element.assetId">
                                {{element.assetTitle}}
                            </a>
                            <span *ngIf="!element.assetExists">
                                {{element.assetTitle}}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Profile Name Column -->
                    <ng-container matColumnDef="profile">
                        <th mat-header-cell *matHeaderCellDef> {{'gen_rented_by' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.profileName}}
                        </td>
                    </ng-container>

                    <!-- Price Column -->
                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef> {{'gen_price' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            {{env.priceUnit + element.total}}
                        </td>
                    </ng-container>

                    <!-- Payment Method Column -->
                    <ng-container matColumnDef="method">
                        <th mat-header-cell *matHeaderCellDef> {{'gen_payment_method' | translate}} </th>
                        <td mat-cell *matCellDef="let element">
                            <i class="{{element.method | mapPaymentMethod}}"></i>
                        </td>
                    </ng-container>

                    <!-- Date Column -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> {{'gen_date' | translate}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.updated | momentPipe:'DD/MM/YYYY'}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </div>
    </div>
</div>